// extracted by mini-css-extract-plugin
module.exports = {"container":"FormInput_container__1kGXK","label":"FormInput_label__3YKDU","input":"FormInput_input__2yu0G"};